import Axios from "./Axios";
import { CountProps } from "./types";
import { getBaseUrl } from '../constants/Constants';

const baseUrl = getBaseUrl();
const getTemplateCountUrl = "/v1/templates/count";

/**
 * [GET] Template Count API
 * @param reviewStatus : 갯수를 조회할 상태 (미입력시 default Preparing)
 * @returns Promise
 */
export const getTemplateCount = ({
  reviewStatus
} : CountProps) => {
  const method = "GET";
  const url = `${baseUrl}${getTemplateCountUrl}`;
  if (reviewStatus) {
    const data = { reviewStatus };
    return Axios(method, url, data);
  } else {
    return Axios(method, url);
  }
};
